import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Master substation layouts, primary equipment, protection relays, earthing, automation and testing. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nuhj4kutefvc">
      <MetaPixel data-id="element-1" data-mp="stc7s3fgqynd" />
      <main data-id="element-2" data-mp="sssrss9dikbz">
        <Hero data-id="element-3" data-mp="swgkxqawp4q6" />
        <LookInsideCarousel data-id="element-4" data-mp="36hvn4muyo06" />
        <ProblemSection data-id="element-5" data-mp="35ovimiemwr0" />
        <SystemSection data-id="element-6" data-mp="34x31kk3tf4y" />
        <ModulesSection data-id="element-7" data-mp="38b5stwojqcx" />
        <BonusSection data-id="element-8" data-mp="3ud1e95yxri91" />
        <UrgencySection data-id="element-9" data-mp="3ubrgkhvzwc2x" />
        <PricingSection data-id="element-10" data-mp="3ucjc5sple9t7" />
        <GuaranteeSection data-id="element-11" data-mp="3uf5g7id9y76o" />
        <FAQ data-id="element-12" data-mp="d57fv4288kjl" />
        <ClosingSection data-id="element-13" data-mp="d3mkxdc02zl7" />
        <SummaryTable data-id="element-14" data-mp="d45v27vesjoo" />
        <FinalCta data-id="element-15" data-mp="d2bgrcen7ptk" />
      </main>
      <Footer data-id="element-16" data-mp="851n1kk80rzx" />
      <PurchaseNotification data-id="element-17" data-mp="86mgt7ypo6wq" />
    </div>;
}